import { useAuth } from '../lib/auth';
import { PageHeader } from '../components/Common';
import { DriveBrowser } from '../../components/DriveBrowser';

export default function Drive() {
  const { user } = useAuth();
  return (
    <div className="page" data-testid="workspace-drive">
      <PageHeader
        eyebrow="PRIVATE VAULT"
        title="My Drive"
        subtitle={`${user.name}'s private file vault — only you and the administrator can see these files.`}
      />
      <div className="card" style={{ padding: 24 }}>
        <DriveBrowser />
      </div>
    </div>
  );
}
